import { useContext } from "react";
import { WizardContext } from "../contexts/WizardContext";

export const useWizard = () => useContext(WizardContext);
